var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-FlashReport_Icon_User",style:(("background-image: url('" + _vm.image + "')"))})}
var staticRenderFns = []

export { render, staticRenderFns }